import LiteralCurrency from './LiteralCurrency';

export default LiteralCurrency;
